'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _components2 = require('components');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _info = require('redux/modules/info');

var _docs = require('redux/modules/docs');

var _AgamaText = require('../../helpers/AgamaText');

var _utils = require('../../../api/actions/Db/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  NewSong: {
    displayName: 'NewSong'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/containers/Create/NewSong.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Helmet from 'react-helmet';

// import { isSongsLoaded, loadSongs, isDocumentLoaded, loadDocument } from 'redux/modules/docs';


var NewSong = _wrapComponent('NewSong')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ setUiProps: _info.setUiProps, changeSongText: _docs.changeSongText, changeSongProp: _docs.changeSongProp, changeSongTextPersistent: _docs.changeSongTextPersistent, panelVisibleToSide: _info.panelVisibleToSide }, dispatch);
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(NewSong, _Component);

  function NewSong() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NewSong);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NewSong.__proto__ || (0, _getPrototypeOf2.default)(NewSong)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showKitten: false
    }, _this.handleToggleKitten = function () {
      return _this.setState({ showKitten: !_this.state.showKitten });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NewSong, [{
    key: 'render',
    value: function render() {
      var showKitten = this.state.showKitten;
      //const kitten = require('./kitten.jpg');

      return _react3.default.createElement(
        'div',
        { className: 'container scrollable' },
        _react3.default.createElement(_components2.Song, { xid: 'newSong', path: '/' + 'x' + '/' + 'y' + '/' + 'x' + '/' + 'x' }),
        ';'
      );
    }
  }]);
  return NewSong;
}(_react2.Component)) || _class));

exports.default = NewSong;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Create/NewSong.js
// module id = 1206
// module chunks = 0